function requireAll(r) { r.keys().forEach(r); }

requireAll( require.context( './ico/', true ) );
requireAll( require.context( './svg/', true, /\.svg$/) );
requireAll( require.context( './fonts/', true ) );
requireAll( require.context( './admin-thumbs/', true, /\.png$/) );
requireAll( require.context( './png/', true, /\.png$/) );
//requireAll( require.context( './gif/', true, /\.gif$/) );

import $ from 'jquery';

window.jQuery = $;
window.$ = $;

import Swiper from 'swiper';
import { Pagination, Navigation, Controller, EffectFade } from 'swiper/modules';

// import { gsap } from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// gsap.registerPlugin(ScrollTrigger);

$(function () {

	var PROJECT = {

		common: {

			getViewport: function() {

				var viewPortWidth;
				var viewPortHeight;

				if (typeof window.innerWidth !== 'undefined') {

					viewPortWidth = window.innerWidth;
					viewPortHeight = window.innerHeight;

				} else if ( typeof document.documentElement !== 'undefined' &&
							typeof document.documentElement.clientWidth !== 'undefined' &&
							document.documentElement.clientWidth !== 0 ) {

					viewPortWidth = document.documentElement.clientWidth;
					viewPortHeight = document.documentElement.clientHeight;

				} else {

					viewPortWidth = document.getElementsByTagName('body')[0].clientWidth;
					viewPortHeight = document.getElementsByTagName('body')[0].clientHeight;
				}

				return { width : viewPortWidth , height : viewPortHeight };

			},

			init: function () {

				PROJECT.scrollDetection.init();

				PROJECT.simpleAnimations.init();
				
				PROJECT.nav.init();

				PROJECT.toggle.init();

				PROJECT.gform.init();

				PROJECT.carousel.init();

				PROJECT.header.init();

			}

		},

		scrollDetection: {

			htmlEl: document.querySelector('html'),
			isInit: true,

			init: function() {

				let oldValue = 0;
				let newValue = 0;
				let offsetTop = 30;
				let offsetScroll = 30;
				let scrollTimeout = false;

				PROJECT.scrollDetection.updateClasses(window.pageYOffset, 0, offsetTop);

				window.addEventListener('scroll', (e) => {

					newValue = window.pageYOffset;
					let difference = Math.abs(newValue - oldValue);
					
					if ( (difference >= offsetScroll) || newValue <= offsetTop ) {

						clearTimeout(scrollTimeout);
						PROJECT.scrollDetection.updateClasses(newValue, oldValue, offsetTop);
						oldValue = newValue;

					} else if ( newValue > offsetTop ) {

						PROJECT.scrollDetection.updateClasses(newValue, oldValue, offsetTop);

					} else {

						scrollTimeout = setTimeout(function(){
							oldValue = newValue;
						}, 500);

					}
					
				});

			},

			updateClasses: function(newValue, oldValue, offsetTop) {

				let htmlEl = PROJECT.scrollDetection.htmlEl;

				if ( newValue <= offsetTop ) {

					htmlEl.classList.remove('state--scroll-up');
					htmlEl.classList.remove('state--scroll-down');

					if (!htmlEl.classList.contains('state--scroll-at-top')) {
						htmlEl.classList.add('state--scroll-at-top');
					}
					if (htmlEl.classList.contains('state--scroll-not-at-top')) {
						htmlEl.classList.remove('state--scroll-not-at-top');
					}

				} else {

					if (htmlEl.classList.contains('state--scroll-at-top')) {
						htmlEl.classList.remove('state--scroll-at-top');
					}
					if (!htmlEl.classList.contains('state--scroll-not-at-top')) {
						htmlEl.classList.add('state--scroll-not-at-top');
					}

					if (oldValue < newValue) {
						
						if (!htmlEl.classList.contains('state--scroll-down')) {
							htmlEl.classList.remove('state--scroll-up');
							htmlEl.classList.add('state--scroll-down');
						}

					} else if (oldValue > newValue) {
						
						if (!htmlEl.classList.contains('state--scroll-up')) {
							htmlEl.classList.add('state--scroll-up');
							htmlEl.classList.remove('state--scroll-down');
						}

					}

				}

			}

		},

		simpleAnimations: {

			init: function() {

				PROJECT.simpleAnimations.initClassAnimations();
				PROJECT.simpleAnimations.initTitleAnimations();
				PROJECT.simpleAnimations.initUspsAnimations();

			},

			initClassAnimations: function() {

				var animateElms = document.querySelectorAll('.jsCircusIconAnimated, .jsIconFlagsAnimated, .jsFadeBottom, .jsFadeRight');

				if ( typeof animateElms === 'object' && animateElms.length > 0 ) {

					// Define observer instance
					var observer = new IntersectionObserver(onIntersection, {
						root: null,  	// default is the viewport
						threshold: .95	// percentage of target's visible area. Triggers "onIntersection"
					});

					// callback is called on intersection change
					function onIntersection(entries, opts) {

						for ( let j=0; j < entries.length; j++ ) {

							let entry = entries[j];

							// One time animations
							if ( entry.isIntersecting ) {

								let thisElm = entry.target;

								if ( thisElm.classList.contains('a-circus') ) {

									thisElm.classList.add('a-circus--animated-trigger');
		
								} else if ( thisElm.classList.contains('a-icon-flags') ) {
		
									thisElm.classList.add('a-icon-flags--animated-trigger');
		
								} else if ( thisElm.classList.contains('s-usps') ) {

									thisElm.classList.add('s-usps--animated-trigger');
		
								} else if ( thisElm.classList.contains('jsFadeBottom') ) {

									thisElm.classList.add('animDone');
		
								} else if ( thisElm.classList.contains('jsFadeRight') ) {

									thisElm.classList.add('animDone');
		
								}



								// Stop observing:
								observer.unobserve(thisElm);

							}

						}

						// entries.forEach(entry => 
						// 	entry.target.classList.toggle('a-circus--animated-trigger', entry.isIntersecting)
						// );
					}

					for (let i=0; i < animateElms.length; i++) {
						
						let thisElm = animateElms[i];

						if ( thisElm.classList.contains('a-circus') ) {

							thisElm.classList.add('a-circus--animated');

						} else if ( thisElm.classList.contains('a-icon-flags') ) {

							thisElm.classList.add('a-icon-flags--animated');

						} else if ( thisElm.classList.contains('s-usps') ) {

							thisElm.classList.add('s-usps--animated');

						}

						// Use the observer to observe an element
						observer.observe( thisElm );
						
					}

				}
				
			},

			initUspsAnimations: function() {

				var animateElms = document.querySelectorAll('.jsUspsAnimated');

				if ( typeof animateElms === 'object' && animateElms.length > 0 ) {

					// Define observer instance
					var observer = new IntersectionObserver(onIntersection, {
						root: null,  	// default is the viewport
						threshold: .4	// percentage of target's visible area. Triggers "onIntersection"
					});

					// callback is called on intersection change
					function onIntersection(entries, opts) {

						for ( let j=0; j < entries.length; j++ ) {

							let entry = entries[j];

							// One time animations
							if ( entry.isIntersecting ) {

								let thisElm = entry.target;

								if ( thisElm.classList.contains('s-usps') ) {

									thisElm.classList.add('s-usps--animated-trigger');
		
								}

								// Stop observing:
								observer.unobserve(thisElm);

							}

						}

					}

					for (let i=0; i < animateElms.length; i++) {
						
						let thisElm = animateElms[i];

						if ( thisElm.classList.contains('s-usps') ) {

							thisElm.classList.add('s-usps--animated');

						}

						// Use the observer to observe an element
						observer.observe( thisElm );
						
					}

				}
				
			},

			initTitleAnimations: function() {

				var animateElms = document.querySelectorAll('.jsScrollLetters');

				if ( typeof animateElms === 'object' && animateElms.length > 0 ) {

					// Define observer instance
					var observer = new IntersectionObserver(onIntersection, {
						root: null,  	// default is the viewport
						threshold: .95	// percentage of target's visible area. Triggers "onIntersection"
					});

					// callback is called on intersection change
					function onIntersection(entries, opts) {

						for ( let j=0; j < entries.length; j++ ) {

							let entry = entries[j];

							// One time animations
							if ( entry.isIntersecting ) {

								var delay = 0;
								let thisElm = entry.target;
								let words = thisElm.querySelectorAll('.word');

								if ( typeof words === 'object' && words.length > 0 ) {

									words.forEach((word) => {

										setTimeout( function() {

											word.classList.add('animDone');

										},delay);

										delay = delay + 200;

									});

								}

								observer.unobserve(thisElm);

							}

						}

					}

					animateElms.forEach((el) => {

						observer.observe( el );

					});

				}

			}

		},

		toggle: {

			/*
			 * Toggle Text in Button label
			 * Used in jsnNavToggle
			 */

			clickElm: '.jsToggleText',
			labelElm: '.jsToggleTextLabel',
			dataAttr: 'toggle-text',

			init: function() {

				$( document ).on( 'click', PROJECT.toggle.clickElm, PROJECT.toggle.switch );

			},

			switch: function( e ) {

				let $elm =  $( this );

				let $label = $elm.find( PROJECT.toggle.labelElm );

				let toggleText = $elm.data( PROJECT.toggle.dataAttr );

				let currentText = $label.text();

				let newText = currentText == toggleText.current ? toggleText.toggle : toggleText.current;

				$label.text( newText );

				$elm.attr( 'title', newText );

			}

		},

		nav: {

			/*
			 * Toggle Core Nav Visibility
			 * - Sets a css class on html elmement
			 * - Disable tabsindex when menu is closed
			 * - Click and Key controlled
			 */


			mainElm: '.navMain',
			clickElm: '.jsNavToggle',
			openClass: 'state-c-header--nav-open',


			init: function() {

				$( document ).on( 'click', PROJECT.nav.clickElm, PROJECT.nav.toggle );

				$( document ).on( 'keyup', PROJECT.nav.esc );

				$( PROJECT.nav.mainElm + ' a' ).each( function() {

					$( this ).attr('tabindex', -1 );

				});

			},

			toggle: function() {

				if ( $( 'html' ).hasClass( PROJECT.nav.openClass ) ) {

					PROJECT.nav.close();

				} else {

					PROJECT.nav.open();
				}
			},

			esc: function( e ) {

				if ( e.keyCode === 27 ) {

					PROJECT.nav.close();

				}
			},

			open: function() {

				$( 'html' ).addClass( PROJECT.nav.openClass );

				$( PROJECT.nav.mainElm + ' a').each( function() {

					$( this ).removeAttr('tabindex', -1 );

				});

			},

			close: function() {

				$( 'html' ).removeClass( PROJECT.nav.openClass );

				$( PROJECT.nav.mainElm  + ' a' ).each( function() {

					$( this ).attr('tabindex', -1 );

				});

			}


		},

		gform: {

			init: function() {

				$( document ).on( 'gform_post_render', PROJECT.gform.hideLoader );

				$( document ).on( 'click.loader', '.gform_button', PROJECT.gform.showLoader );
				$( document ).on( 'click.loader', '.gform_next_button, gform_previous_button', PROJECT.gform.showLoader );
				$( document ).on( 'submit', '.gform_wrapper form', PROJECT.gform.showLoader );

				$( document ).on( 'gform_page_loaded', PROJECT.gform.hideLoader );

				$( document ).on( 'gform_confirmation_loaded', PROJECT.gform.showConfirmation );
				$( document ).on( 'click.loader', '.gformCloseConfirmation', PROJECT.gform.hideConfirmation );


				$( document ).on( 'focus', 'input, textarea, select', function() {
					$( this ).parents( '.gfield' ).addClass( 'state--has-focus' );
				});

				$( document ).on( 'blur', 'input, textarea, select', function( e ) {
					if( !$(this).val() ) {
						$( this ).parents( '.gfield' ).removeClass( 'state--has-focus' );
					}
				});

				PROJECT.gform.fixHasFocus();

			},

			fixHasFocus: function() {

				$( 'input, textarea, select' ).each(function() {

					if( $(this).val() ) {
						$( this ).parents( '.gfield' ).addClass( 'state--has-focus' );
					}

				});

			},

			showLoader: function() {

				var $gformContainer = $(this).closest( '.gformContainer' );
				var $gformLoader = $gformContainer.find( '.gformLoader' );

				$gformLoader.fadeIn( 300 ).css( 'display', 'flex' );

			},

			hideLoader: function() {

				$( '.gformLoader' ).fadeOut( 300 );
				PROJECT.gform.fixHasFocus();

			},

			showConfirmation: function() {

				$( '.gformConfirmation' ).fadeIn( 300 ).css( 'display', 'flex' );

			},

			hideConfirmation: function() {

				$( '.gformConfirmation' ).fadeOut( 300 );

			}

		},

		carousel: {
			
			init: function() {

				PROJECT.carousel.cardCarousel();
				
			},

			cardCarousel: function() {

				const carousels = document.querySelectorAll( '.jsCarouselCardsSection' );

				if( carousels.length > 0 ) {

					carousels.forEach((carousel, index) => {

						const carouselCardPrev = carousel.querySelector( '.jsCarouselCardPrev' );
						const carouselCardNext = carousel.querySelector( '.jsCarouselCardNext' );
						const carouselCardPager = carousel.querySelector( '.jsCarouselCardPager' );

						const carouselCards = new Swiper( carousel.querySelector( '.jsCarouselCards' ), {
							
							modules: [Navigation, Pagination, Controller],

							loop: true,
							
							slidesPerView: 1,
							slidesPerGroup: 1,

							centeredSlides: true,

							loopAdditionalSlides: 2,

							navigation: {

								nextEl: carouselCardNext,
								prevEl: carouselCardPrev,

							},

							pagination: {

								el: carouselCardPager,
								clickable: true,
								type: 'bullets',

								bulletClass: 's-carousel-cards__page',
								bulletActiveClass: 's-carousel-cards__page--active'

							},
							
						});

						const carouselCardNames = new Swiper( carousel.querySelector( '.jsCarouselCardInfo' ), {
							
							modules: [EffectFade, Controller],

							effect: 'fade',

							loop: true,

							loopAdditionalSlides: 2,
							
							fadeEffect: {
								
								crossFade: true

							},

							centeredSlides: true,

							slidesPerView: 1,
							slidesPerGroup: 1,
							
						});

						carouselCards.controller.control = carouselCardNames;
						carouselCardNames.controller.control = carouselCards;

					});

				}

			},

		},

		header: {

			init: function() {

				PROJECT.header.getHeight( '.jsSiteHeader','--header-site-height');
				PROJECT.header.getHeight( '.jsHeaderTop','--header-banner-height');

				window.onresize = function() {

					PROJECT.header.getHeight( '.jsSiteHeader','--header-site-height');
					PROJECT.header.getHeight('.jsHeaderTop','--header-banner-height');

				}

			},

			getHeight: function( targetClass,cssVariable ) {

				var $this = $(targetClass);

				if( $this.length > 0 ) {

					$( 'html' ).css( cssVariable,$this.height());

				}

			}

		}

	};

	var UTIL = {

		exec: function (controller, action) {

			var ns = PROJECT;
			action = (action === undefined) ? 'init' : action;

			if (controller !== '' && ns[controller] && typeof ns[controller][action] === 'function') {

				ns[controller][action]();

			}

		},

		init: function () {

			var body = document.body,
				controller = body.getAttribute('data-controller'),
				action = body.getAttribute('data-action');

			UTIL.exec('common');
			UTIL.exec(controller);
			UTIL.exec(controller, action);

		}

	};

	//$.PROJECT = PROJECT; // Make global available

	$(window).ready(UTIL.init);

});
